import { consulta } from "../../../global/js/funciones";

const programasEndpoint = "api/v1.0/integraciones/moodle/programas";
const resultadosEndpoint = "api/v1.0/integraciones/resultado/pruebas";
const resultadosResumenEndpoint = "api/v1.0/integraciones/resultado/pruebas/resumen";
const resultadosTendenciasEndpoint = "api/v1.0/integraciones/resultado/pruebas/tendencias";
const resultadosGlobalEndpoint = "api/v1.0/integraciones/resultado/pruebas/global";
const resultadosProgramasEndpoint = "api/v1.0/integraciones/resultado/pruebas/programas";
const competenciasEndpoint = "api/v1.0/integraciones/alertas/competencias";

/** Valor interno de los selects “Todos” en la vista Resumen. */
export const FILTRO_TODOS = "__todos__";

export const esFiltroTodos = (valor) => {
  if (valor === undefined || valor === null || valor === "") return true;
  const s = String(valor).trim().toLowerCase();
  return s === "todos" || s === FILTRO_TODOS || s === "__todos__" || s === "*";
};
const prediccionAlertasEndpoint = "api/v1.0/integraciones/prediccion/alertas";
const personasMasivoCorreosEndpoint = "api/v1.0/personas/buscar_masivo_correos";

let programasCache = null;
let programasPending = null;
const resultadosCache = new Map();
const resultadosPending = new Map();
const personaTendenciasCache = new Map();

const request = (url) =>
  new Promise((resolve) => {
    consulta(
      url,
      null,
      "GET",
      (error, estado, response) => {
        if (estado === 200) {
          resolve(response);
          return;
        }
        resolve(null);
      },
      true
    );
  });

const requestPost = (url, body) =>
  new Promise((resolve) => {
    consulta(
      url,
      body,
      "post",
      (error, estado, response) => {
        if (estado === 200) {
          resolve(response);
          return;
        }
        resolve(null);
      },
      true
    );
  });

const normalizeListPayload = (response) => {
  if (!response) return { results: [], next: null };
  if (Array.isArray(response)) return { results: response, next: null };
  const results = response.results ?? response.data ?? [];
  return { results, next: response.next ?? null };
};

const buildResultadosQuery = (params = {}) => {
  const q = new URLSearchParams();
  if (params.Correo) q.append("Correo", params.Correo);
  if (params.competencia) q.append("competencia", params.competencia);
  if (params.anio !== undefined && params.anio !== null && params.anio !== "") {
    q.append("anio", String(params.anio));
  }
  if (params.semestre !== undefined && params.semestre !== null && params.semestre !== "") {
    q.append("semestre", String(params.semestre));
  }
  if (params.Prueba) q.append("Prueba", params.Prueba);
  if (params.programa) q.append("programa", params.programa);
  if (params.page) q.append("page", String(params.page));
  if (params.page_size) q.append("page_size", String(params.page_size));
  if (params.sin_programa_nombre) q.append("sin_programa_nombre", "1");
  if (params.con_datos_persona) q.append("con_datos_persona", "1");
  const qs = q.toString();
  return qs ? `?${qs}` : "";
};

const nextUrlToRelativePath = (next) => {
  if (!next || typeof next !== "string") return null;
  if (next.startsWith("http")) {
    try {
      const u = new URL(next);
      return u.pathname.replace(/^\//, "") + u.search;
    } catch {
      return null;
    }
  }
  return next.replace(/^\//, "");
};

export const getResultadoPruebasList = async (params = {}, options = {}) => {
  const { fetchAllPages = false } = options;
  const pageSize = params.page_size ?? 5000;
  const all = [];
  let url = `${resultadosEndpoint}${buildResultadosQuery({ ...params, page: 1, page_size: pageSize })}`;

  for (let p = 0; p < 120; p += 1) {
    const resp = await request(url);
    const { results, next } = normalizeListPayload(resp);
    all.push(...(Array.isArray(results) ? results : []));
    if (!fetchAllPages) break;
    const rel = nextUrlToRelativePath(next);
    if (!rel) break;
    url = rel;
  }

  return all;
};

export const getPrediccionAlertas = async ({ Correo, alerta, competencia, page_size = 50 } = {}) => {
  if (!Correo) return [];
  const q = new URLSearchParams();
  q.append("Correo", Correo);
  if (alerta) q.append("alerta", alerta);
  if (competencia) q.append("competencia", competencia);
  q.append("page_size", String(page_size));
  const resp = await request(`${prediccionAlertasEndpoint}?${q.toString()}`);
  const { results } = normalizeListPayload(resp);
  return Array.isArray(results) ? results : [];
};

export const buscarCorreosPersonasPorDato = async (dato) => {
  const trimmed = (dato || "").trim();
  if (trimmed.length < 4) return [];
  const lista = await requestPost("api/v1.0/personas/buscar", { dato: trimmed });
  if (!Array.isArray(lista)) return [];
  const orden = new Map();
  lista.forEach((p) => {
    const c = (p.correo || "").trim();
    if (c) orden.set(c.toLowerCase(), c);
  });
  return [...orden.values()].slice(0, 30);
};

export const getPersonaTendenciasPorCorreo = async (correoInstitucional) => {
  const trimmed = (correoInstitucional || "").trim();
  if (trimmed.length < 4) return null;
  const cacheKey = trimmed.toLowerCase();
  if (personaTendenciasCache.has(cacheKey)) {
    return personaTendenciasCache.get(cacheKey);
  }

  const lista = await requestPost("api/v1.0/personas/buscar", { dato: trimmed });
  if (!Array.isArray(lista) || lista.length === 0) {
    const fallback = {
      id: null,
      nombreCompleto: "",
      correo: trimmed,
      correo_personal: "",
      telefono: "",
      celular: "",
      programa: "",
    };
    personaTendenciasCache.set(cacheKey, fallback);
    return fallback;
  }

  const lower = trimmed.toLowerCase();
  const match =
    lista.find((p) => (p.correo || "").toLowerCase() === lower) ||
    lista.find((p) => (p.usuario || "").toLowerCase() === lower.split("@")[0]) ||
    lista[0];

  const nombreCompleto = [
    match.primer_nombre,
    match.segundo_nombre,
    match.primer_apellido,
    match.segundo_apellido,
  ]
    .filter(Boolean)
    .join(" ")
    .trim();

  let programa = "";
  if (match.id) {
    const progsRaw = await request(`api/v1.0/personas/${match.id}/programas`);
    const progs = Array.isArray(progsRaw) ? progsRaw : [];
    programa = progs
      .map((g) => {
        const rel = g.relacion;
        if (!rel) return "";
        if (typeof rel === "object") return rel.nombre || rel.descripcion || rel.valorb || "";
        return "";
      })
      .filter(Boolean)
      .join(", ");
  }

  const telefono = match.telefono != null && String(match.telefono).trim() ? String(match.telefono).trim() : "";
  const celular = [match.indicativo_celular, match.celular]
    .filter((x) => x != null && String(x).trim() !== "")
    .join(" ")
    .trim();

  const persona = {
    id: match.id,
    nombreCompleto,
    correo: match.correo || trimmed,
    correo_personal: match.correo_personal || "",
    telefono,
    celular,
    programa,
  };
  personaTendenciasCache.set(cacheKey, persona);
  return persona;
};

const personaDetalleDesdePersonaList = (match) => {
  if (!match) return null;
  const nombreCompleto = [
    match.primer_nombre,
    match.segundo_nombre,
    match.primer_apellido,
    match.segundo_apellido,
  ]
    .filter(Boolean)
    .join(" ")
    .trim();
  const telefono = match.telefono != null && String(match.telefono).trim() ? String(match.telefono).trim() : "";
  const celular = [match.indicativo_celular, match.celular]
    .filter((x) => x != null && String(x).trim() !== "")
    .join(" ")
    .trim();
  return {
    id: match.id,
    nombreCompleto,
    correo: match.correo || "",
    correo_personal: match.correo_personal || "",
    telefono,
    celular,
    programa: "",
  };
};

/** Lotes paralelos para buscar_masivo_correos (límite backend 1500 por request). */
const MASIVO_CORREOS_CHUNK = 1400;

/**
 * Una o varias peticiones POST en paralelo para enriquecer exportes Excel.
 */
export const getPersonasTendenciasPorCorreos = async (correos = []) => {
  if (!Array.isArray(correos) || correos.length === 0) return new Map();
  const unicos = [...new Set(correos.map((c) => (c || "").trim()).filter(Boolean))];
  if (unicos.length === 0) return new Map();

  const chunks = [];
  for (let i = 0; i < unicos.length; i += MASIVO_CORREOS_CHUNK) {
    chunks.push(unicos.slice(i, i + MASIVO_CORREOS_CHUNK));
  }

  const listas = await Promise.all(
    chunks.map((chunk) => requestPost(personasMasivoCorreosEndpoint, { correos: chunk }))
  );

  const porCorreoLower = new Map();
  listas.forEach((resp) => {
    const lista = Array.isArray(resp) ? resp : [];
    lista.forEach((p) => {
      const c = (p.correo || "").trim();
      if (c) porCorreoLower.set(c.toLowerCase(), p);
    });
  });

  const mapa = new Map();
  unicos.forEach((correo) => {
    const key = correo.toLowerCase();
    const match = porCorreoLower.get(key);
    const detalle = personaDetalleDesdePersonaList(match);
    mapa.set(
      key,
      detalle || {
        id: null,
        nombreCompleto: "",
        correo,
        correo_personal: "",
        telefono: "",
        celular: "",
        programa: "",
      }
    );
  });
  return mapa;
};

let programasPruebasCacheAll = null;
let programasPruebasPendingAll = null;

export const getCompetenciasAlertas = async () => {
  const resp = await request(competenciasEndpoint);
  if (!Array.isArray(resp)) return [];
  return resp
    .map((item) => ({
      codigo: String(item?.codigo || "").trim(),
      nombre: String(item?.nombre || "").trim(),
      // Subcompetencias (C1..C7) de esta competencia, con nombre; vienen del
      // backend para no depender de que ya haya datos de resumen/tendencias
      // cargados para conocer los códigos y etiquetas disponibles.
      subcompetencias: Array.isArray(item?.subcompetencias)
        ? item.subcompetencias
            .map((sub) => ({
              codigo: String(sub?.codigo || "").trim(),
              nombre: String(sub?.nombre || "").trim(),
            }))
            .filter((sub) => sub.codigo)
        : [],
    }))
    .filter((item) => item.codigo);
};

/** Programas que tienen filas en resultado/pruebas (opcional anio/semestre). */
export const getProgramasConResultadosPruebas = async ({ anio, semestre, competencia } = {}) => {
  const q = new URLSearchParams();
  if (anio !== undefined && anio !== null && anio !== "") q.append("anio", String(anio));
  if (semestre !== undefined && semestre !== null && semestre !== "") q.append("semestre", String(semestre));
  if (competencia) q.append("competencia", competencia);
  const qs = q.toString();
  const sinFiltros = !qs;

  if (sinFiltros && Array.isArray(programasPruebasCacheAll)) return programasPruebasCacheAll;

  if (sinFiltros && programasPruebasPendingAll) return programasPruebasPendingAll;

  const fetchList = request(qs ? `${resultadosProgramasEndpoint}?${qs}` : resultadosProgramasEndpoint).then(
    (resp) => {
      const raw = resp && typeof resp === "object" ? resp.programas : null;
      const list = Array.isArray(raw) ? raw : [];
      if (sinFiltros) {
        programasPruebasCacheAll = list;
        programasPruebasPendingAll = null;
      }
      return list;
    }
  );

  if (sinFiltros) programasPruebasPendingAll = fetchList;
  return fetchList;
};

export const getProgramasResumen = async (competencia = "RC") => {
  const cacheKey = competencia || "RC";
  if (Array.isArray(programasCache) && programasCache.competencia === cacheKey) return programasCache.data;

  if (!programasPending || programasPending.competencia !== cacheKey) {
    programasPending = request(`${programasEndpoint}${competencia ? `?competencia=${encodeURIComponent(competencia)}` : ""}`).then((response) => {
      const data = Array.isArray(response) ? response : response?.results || response?.data || [];
      programasCache = { competencia: cacheKey, data };
      programasPending = null;
      return data;
    });
    programasPending.competencia = cacheKey;
  }

  return programasPending;
};

/** @deprecated Usar getGlobalDistribucion */
export const getResultadosPruebasPorPrograma = async (programa) => {
  const r = await getGlobalDistribucion(programa);
  return (r.puntajes || []).map((p) => ({
    Correo: p.correo,
    Total: p.total,
    programa_nombre: programa,
  }));
};

const globalDistribucionVacio = () => ({
  puntajes: [],
  stats: {
    min: null,
    max: null,
    q1: null,
    median: null,
    q3: null,
    iqr: null,
    lowerFence: null,
    upperFence: null,
    whiskerLow: null,
    whiskerHigh: null,
  },
});

const globalCache = new Map();
const globalPending = new Map();

/** Vista Global: puntajes + boxplot en una petición (sin paginar todo el programa). */
export const getGlobalDistribucion = async (programa, competencia = "RC") => {
  const trimmed = (programa || "").trim();
  if (!trimmed) return globalDistribucionVacio();

  const key = `${(competencia || "RC").toLowerCase()}::${trimmed.toLowerCase()}`;
  if (globalCache.has(key)) return globalCache.get(key);

  if (!globalPending.has(key)) {
    const q = new URLSearchParams({ programa: trimmed, competencia: competencia || "RC" });
    const pending = request(`${resultadosGlobalEndpoint}?${q.toString()}`).then((response) => {
      const payload =
        response && typeof response === "object" ? response : globalDistribucionVacio();
      if (!Array.isArray(payload.puntajes)) payload.puntajes = [];
      if (!payload.stats || typeof payload.stats !== "object") {
        payload.stats = globalDistribucionVacio().stats;
      }
      globalCache.set(key, payload);
      globalPending.delete(key);
      return payload;
    });
    globalPending.set(key, pending);
  }

  return globalPending.get(key);
};

export const registrarAcceso = () =>
  requestPost("api/v1.0/integraciones/alerta_generica/acceso", {});

const buildResumenQuery = ({ anio, semestre, programa, competencia, modo, limitePorColor } = {}) => {
  const q = new URLSearchParams();
  if (!esFiltroTodos(anio)) q.append("anio", String(anio));
  if (!esFiltroTodos(semestre)) q.append("semestre", String(semestre));
  if (!esFiltroTodos(programa)) q.append("programa", String(programa).trim());
  if (competencia) q.append("competencia", String(competencia));
  if (modo) q.append("modo", modo);
  if (limitePorColor != null) q.append("limite_por_color", String(limitePorColor));
  const qs = q.toString();
  return qs ? `?${qs}` : "";
};

const resumenTablaCache = new Map();
const resumenTablaPending = new Map();

/** Tabla Resumen: máx. 8 por color, un registro por estudiante (correo). */
export const getTablaResumen = async ({ anio, semestre, programa, competencia, limitePorColor = 8 } = {}) => {
  const query = buildResumenQuery({ anio, semestre, programa, competencia, modo: "tabla", limitePorColor });
  const cacheKey = `tabla${query}`;

  if (resumenTablaCache.has(cacheKey)) return resumenTablaCache.get(cacheKey);

  if (!resumenTablaPending.has(cacheKey)) {
    const pending = request(`${resultadosResumenEndpoint}${query}`).then((response) => {
      const payload = response && typeof response === "object"
        ? response
        : { filas: [], totales: { verde: 0, amarillo: 0, rojo: 0 }, total_estudiantes: 0 };
      if (!Array.isArray(payload.filas)) payload.filas = [];
      resumenTablaCache.set(cacheKey, payload);
      resumenTablaPending.delete(cacheKey);
      return payload;
    });
    resumenTablaPending.set(cacheKey, pending);
  }

  return resumenTablaPending.get(cacheKey);
};

/** Excel Resumen: todos los estudiantes únicos según filtros activos (una petición). */
export const getExcelResumen = async ({ anio, semestre, programa, competencia } = {}) => {
  const query = buildResumenQuery({ anio, semestre, programa, competencia, modo: "excel" });
  const response = await request(`${resultadosResumenEndpoint}${query}`);
  const filas = response && typeof response === "object" ? response.filas : null;
  return Array.isArray(filas) ? filas : [];
};

/** @deprecated Usar getTablaResumen */
export const getResultadosResumen = async (params = {}) => {
  const r = await getTablaResumen(params);
  return r.filas || [];
};

const tendenciasCache = new Map();
const tendenciasPending = new Map();

const payloadTendenciasVacio = () => ({
  filas: [],
  persona: {
    nombre: "",
    telefono: "",
    celular: "",
    correo_personal: "",
    programa: "",
  },
  predicciones: [],
});

/** Vista Tendencias: pruebas + contacto + predicciones en una sola petición. */
export const getTendenciasEstudiante = async (correoInstitucional, competencia = "RC") => {
  const trimmed = (correoInstitucional || "").trim();
  if (!trimmed.includes("@")) return payloadTendenciasVacio();

  const cacheKey = `${(competencia || "RC").toLowerCase()}::${trimmed.toLowerCase()}`;
  if (tendenciasCache.has(cacheKey)) return tendenciasCache.get(cacheKey);

  if (!tendenciasPending.has(cacheKey)) {
    const q = new URLSearchParams({ Correo: trimmed, competencia: competencia || "RC" });
    const pending = request(`${resultadosTendenciasEndpoint}?${q.toString()}`).then((response) => {
      const payload =
        response && typeof response === "object" ? response : payloadTendenciasVacio();
      if (!Array.isArray(payload.filas)) payload.filas = [];
      if (!Array.isArray(payload.predicciones)) payload.predicciones = [];
      if (!payload.persona || typeof payload.persona !== "object") {
        payload.persona = payloadTendenciasVacio().persona;
      }
      tendenciasCache.set(cacheKey, payload);
      tendenciasPending.delete(cacheKey);
      return payload;
    });
    tendenciasPending.set(cacheKey, pending);
  }

  return tendenciasPending.get(cacheKey);
};
